var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 172,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m158.003 52.448-14.931-8.62 3.465-16.33V27.232H146.593a.255.255 0 0 1 .223-.01l14.931 8.618c-.312-.387-2.306 11.784-3.744 16.608Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E23B93",
    d: "M146.548 27.498c6.274 7.136 13.751 11.54 13.015 17.736l-1.56 7.214-14.931-8.62 3.476-16.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4FF",
    d: "m157.802 34.225-.334 16.564-15.667-8.974.056-16.43 15.945 8.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5DBF1",
    d: "m157.513 34.369.323-.188-.044 16.42-.323.187.044-16.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCE8F8",
    d: "m141.857 25.385.324-.189 15.655 8.985-.323.188-15.656-8.984Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5DBF1",
    d: "M156.911 47.237v1.04l-14.496-8.31v-1.04l14.496 8.31Zm.034-11.916v1.04l-14.497-8.31v-1.04l14.497 8.31Zm0 1.704-14.486-8.31v1.04l14.486 8.31v-1.04Zm-.011 1.703-14.497-8.309v1.04l14.486 8.31.011-1.04Zm0 1.704-14.497-8.309v1.04l14.497 8.31v-1.04Zm0 1.693-14.497-8.31v1.04l14.497 8.31v-1.04Zm-.011 1.704-14.497-8.31v1.04l14.497 8.31v-1.04Zm0 1.704-14.497-8.31v1.04l14.497 8.31v-1.04Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m153.97 40.576 3.554 12.425c.045.133.145.321.223.399l-14.932-8.62c-.133-.077-.2-.276-.222-.398l-3.555-12.425-.669-2.335a.558.558 0 0 1 .134-.42c.624.564 3.934 2.567 4.535 2.932 1.025.797 1.059 1.781 2.608 3.408.301.31.401.398.769.608l7.555 4.426Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E23B93",
    d: "M154.159 40.1a.202.202 0 0 1 .078-.055c.111-.066.223-.033.256.078l3.522 12.325 3.465-16.33a.559.559 0 0 1 .323-.4c.145-.032.223.09.19.266l-3.488 16.442a2.27 2.27 0 0 1-.212.642.705.705 0 0 1-.278.31c-.112.066-.201.055-.279.01-.078-.055-.145-.187-.201-.387l-3.554-12.425c-.045-.144.033-.354.178-.476Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB84B6",
    d: "m146.883 35.674 7.532 4.349c-.2-.1-.501.343-.445.553l-7.611-4.393a4.164 4.164 0 0 1-.635-.409c-1.081-.852-1.594-2.014-2.296-2.954a3.137 3.137 0 0 0-.601-.609c-.19-.1-.29-.155-.257-.144l-4.201-2.456c-.033-.177.09-.376.134-.42.078-.089.201-.188.312-.133l4.201 2.456c-.033-.01.067.033.256.144.201.155.401.343.602.609.747.995 1.281 2.113 2.496 3.064.178.155.323.244.513.343Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M114.401 16.887c-3.989-2.29-7.477-7.7-7.778-12.082-.301-4.382 2.685-6.074 6.675-3.784 3.989 2.29 7.476 7.7 7.777 12.082.301 4.382-2.685 6.074-6.674 3.784Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m116.351 5.834 1.058.52-4.702 7.114-4.145-6.118 1.371.53 2.184 2.07 4.234-4.116Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEEAE4",
    d: "M126.867 143.636 81.125 117.69c-1.693-.774-4.19-1.494-5.86-.487l-4.257 2.578c-.858.52-3.678 2.235-1.794 3.253 5.549 2.999 40.983 23.556 46.61 26.599 1.07.575 2.619.786 4.257.653 1.627-.133 3.321-.575 4.613-1.361l1.705-1.04c1.203-.741 1.872-1.538 1.939-2.313.067-.763-.424-1.46-1.471-1.936Z",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M125.596 140.826c-.011 2.213-.802 3.762-2.072 4.492l-2.017 1.206c-6.898-2.921-4.335-37.652-4.758-47.522l2.117-51.814c-1.783-3.087-8.636-5.787-7.042-12.105L91.599 25.68c-.902-.609-24.503-14.185-20.269-16.73.713-.42 1.415-.852 2.106-1.261 1.56-.918 3.555-.354 5.026.487L118.72 31.11c3.956 2.257 7.054 7.734 7.042 12.105l-.167 97.61Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.291 13.441c.011-2.168.758-3.706 1.984-4.448 1.292-.785 3.097-.708 5.092.443l40.248 22.925c3.9 2.235 7.054 7.657 7.042 12.105l-.167 97.621c-.011 4.448-3.187 6.24-7.087 4.005l-40.248-22.925c-3.9-2.235-7.053-7.657-7.042-12.105l.178-97.62Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M69.291 13.441c.011-2.168.758-3.706 1.984-4.448 1.292-.785 3.097-.708 5.092.443l40.248 22.925c3.9 2.235 7.054 7.657 7.042 12.105l-.167 97.621c-.011 4.448-3.187 6.24-7.087 4.005l-40.248-22.925c-3.9-2.235-7.053-7.657-7.042-12.105l.178-97.62Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#485AF4",
    d: "M118.042 40.505c1.058.608 1.916.122 1.916-1.084s-.846-2.667-1.905-3.275c-1.059-.609-1.917-.122-1.917 1.084-.011 1.206.847 2.666 1.906 3.275ZM87.477 20.943c0-.332.234-.454.524-.288 4.178 2.346 11.031 6.174 15.221 8.52.29.166.524.575.524.896v.653c0 .332-.234.453-.524.287-4.179-2.345-11.043-6.174-15.221-8.52-.29-.165-.524-.575-.524-.895v-.653Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#6BB6FF",
    d: "M87.175 60.963c0-.897.635-1.24 1.427-.786l17.683 9.925c.78.465 1.416 1.56 1.416 2.456v1.77c0 .897-.636 1.24-1.427.786L88.59 65.189c-.78-.464-1.415-1.56-1.415-2.456v-1.77Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#6BB6FF",
    d: "M77.95 63.84c0-.786.567-1.096 1.247-.687 10.029 5.632 26.465 14.816 36.493 20.437.691.409 1.248 1.371 1.248 2.157v1.56c0 .786-.568 1.096-1.248.686-10.028-5.632-26.464-14.815-36.493-20.436-.69-.41-1.248-1.372-1.248-2.157v-1.56Z",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M79.899 79.108c0-1.161.825-1.626 1.838-1.04 10.765 6.119 21.495 12.459 32.259 18.589 1.014.586 1.839 1.991 1.828 3.153l.055 42.288c0 1.162-.824 1.627-1.849 1.04-10.753-6.13-21.495-12.469-32.248-18.599-1.014-.587-1.838-1.992-1.827-3.153l-.056-42.278Z",
    opacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m79.097 78.378 1.237-.608c.311-.144.724-.1 1.17.155 10.162 5.786 20.313 11.783 30.475 17.57.959.553 1.739 1.88 1.728 2.976l.044 39.965c0 .454-.134.797-.368 1.007-.234.199-1.125.586-1.448.752-10.162-5.787-20.236-12.558-30.41-18.345-.958-.553-1.738-1.881-1.726-2.976l-.702-40.496Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M78.54 79.507c0-1.096.78-1.538 1.738-.985 10.162 5.787 20.313 11.784 30.476 17.57.958.554 1.738 1.881 1.727 2.977l.044 39.964c0 1.096-.78 1.538-1.738.985-10.162-5.787-20.313-11.783-30.476-17.57-.958-.553-1.738-1.881-1.727-2.976l-.044-39.965Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.31 96.49c0-.331.122-.575.311-.696.201-.122.48-.111.792.066l1.36.775c.579.752 1.28 1.405 2.016 1.825.746.432 1.415.553 1.939.42l.97.554c.6.343 1.102 1.195 1.091 1.881l-.01 4.094c-2.831-1.638-5.65-3.275-8.48-4.913l.01-4.005Zm4.423 1.184c1.426.82 2.507.21 2.396-1.36-.112-1.571-1.36-3.508-2.786-4.338-1.437-.818-2.507-.21-2.395 1.361.1 1.582 1.348 3.519 2.785 4.337ZM80.3 98.327c0-.453.323-.642.725-.41 9.683 5.511 19.355 11.032 29.038 16.542.401.232.724.786.713 1.239l.022 4.481c0 .454-.323.642-.724.41-9.683-5.51-19.355-11.032-29.038-16.542-.401-.232-.725-.785-.713-1.239l-.023-4.48Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M85.27 118.254c0-.453.323-.641.724-.409 5.237 2.976 10.463 5.953 15.7 8.929.401.232.724.786.713 1.239l.023 4.481c0 .454-.324.642-.725.41-5.237-2.977-10.463-5.953-15.7-8.929-.401-.233-.724-.786-.713-1.24l-.023-4.481Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.3 106.515c0-.454.323-.642.725-.409 9.683 5.51 19.355 11.031 29.038 16.541.401.232.724.786.713 1.239l.022 4.481c0 .454-.323.642-.724.41-9.683-5.51-19.355-11.032-29.038-16.542-.401-.232-.725-.785-.713-1.239l-.023-4.481Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M107.433 118.276c-1.047-.608-1.972-2.024-2.05-3.186-.078-1.151.702-1.605 1.76-.996 1.048.609 1.973 2.025 2.051 3.187.078 1.15-.713 1.593-1.761.995Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m107.946 115.355.278.144-1.236 1.87-1.092-1.604.356.133.58.553 1.114-1.096Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M107.433 126.033c-1.047-.609-1.972-2.025-2.05-3.187-.078-1.151.702-1.604 1.76-.996 1.048.609 1.973 2.036 2.051 3.187.078 1.151-.713 1.604-1.761.996Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m107.946 123.123.278.133-1.236 1.881-1.092-1.616.356.144.58.542 1.114-1.084Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ED7FA",
    d: "M82.774 100.928a.21.21 0 0 1 .19-.222.21.21 0 0 1 .222.188l.067 1.007.59-.343a.203.203 0 0 1 .28.078.2.2 0 0 1-.079.276l-.568.321.858.487c.1.055.134.188.078.288a.216.216 0 0 1-.29.077l-.434-.254.456.73c.056.1.034.221-.066.288-.1.066-.223.033-.29-.067l-.468-.73.033.509c.012.111-.078.21-.19.221a.21.21 0 0 1-.222-.188l-.067-1.007-.512.299a.204.204 0 1 1-.201-.354l.49-.277-.858-.486a.214.214 0 0 1-.078-.288c.056-.1.19-.133.29-.078l.435.255-.457-.73c-.067-.1-.034-.222.067-.288a.216.216 0 0 1 .29.066l.467.731-.033-.509ZM87.153 103.417c-.011-.11.078-.21.19-.221a.21.21 0 0 1 .222.188l.067 1.007.59-.343a.204.204 0 1 1 .201.354l-.568.321.858.487c.1.055.134.188.078.287a.216.216 0 0 1-.29.078l-.434-.255.456.73c.067.1.034.222-.066.288a.216.216 0 0 1-.29-.066l-.468-.73.033.508a.21.21 0 0 1-.19.222.21.21 0 0 1-.222-.188l-.067-1.007-.513.299a.203.203 0 0 1-.278-.078.2.2 0 0 1 .078-.276l.49-.277-.858-.487a.213.213 0 0 1-.078-.288.217.217 0 0 1 .29-.077l.434.254-.456-.73a.213.213 0 0 1 .067-.288.216.216 0 0 1 .29.067l.467.73-.033-.509ZM91.432 105.829c-.011-.111.078-.21.189-.221a.21.21 0 0 1 .223.188l.067 1.007.59-.343a.203.203 0 0 1 .279.077.2.2 0 0 1-.078.277l-.568.321.858.486c.1.056.133.189.078.288a.216.216 0 0 1-.29.078l-.435-.255.457.73c.067.1.034.222-.067.288-.1.066-.222.033-.29-.066l-.467-.731.033.509a.21.21 0 0 1-.19.222.21.21 0 0 1-.222-.188l-.067-1.007-.513.298a.202.202 0 0 1-.278-.077.2.2 0 0 1 .078-.277l.49-.276-.858-.487a.213.213 0 0 1-.078-.288.216.216 0 0 1 .29-.077l.434.254-.456-.73c-.067-.1-.034-.221.066-.288a.216.216 0 0 1 .29.067l.468.73-.033-.509ZM95.71 108.241c-.01-.11.078-.21.19-.221a.21.21 0 0 1 .223.188l.067 1.007.59-.343a.203.203 0 0 1 .279.078.2.2 0 0 1-.078.276l-.569.321.858.487c.1.055.134.188.078.288a.217.217 0 0 1-.29.077l-.434-.255.457.731a.211.211 0 0 1-.067.287.214.214 0 0 1-.29-.066l-.468-.73.034.509c.011.11-.078.21-.19.221a.209.209 0 0 1-.222-.188l-.067-1.007-.513.299a.203.203 0 0 1-.278-.078.2.2 0 0 1 .078-.276l.49-.277-.858-.487a.212.212 0 0 1-.078-.287c.056-.1.19-.133.29-.078l.434.255-.457-.731c-.067-.099-.033-.221.067-.287.1-.067.223-.033.29.066l.468.73-.034-.509ZM82.774 109.038a.21.21 0 0 1 .19-.222.21.21 0 0 1 .222.188l.067 1.007.59-.343a.203.203 0 0 1 .28.078.2.2 0 0 1-.079.276l-.568.321.858.487c.1.055.134.188.078.288a.217.217 0 0 1-.29.077l-.434-.254.456.73a.213.213 0 0 1-.066.288.216.216 0 0 1-.29-.067l-.468-.73.033.509c.012.111-.078.21-.19.221a.21.21 0 0 1-.222-.188l-.067-1.007-.512.299a.203.203 0 0 1-.279-.078.2.2 0 0 1 .078-.276l.49-.277-.858-.487a.212.212 0 0 1-.078-.287c.056-.1.19-.133.29-.078l.435.255-.457-.73c-.067-.1-.034-.222.067-.288.1-.067.222-.033.29.066l.467.731-.033-.509ZM87.153 111.527c-.011-.11.078-.21.19-.221a.21.21 0 0 1 .222.188l.067 1.007.59-.343a.204.204 0 1 1 .201.354l-.568.321.858.487c.1.055.134.188.078.287a.216.216 0 0 1-.29.078l-.434-.255.456.731c.067.099.034.221-.066.287-.1.067-.223.033-.29-.066l-.468-.73.033.509c.011.11-.078.21-.19.221a.21.21 0 0 1-.222-.188l-.067-1.007-.513.299a.203.203 0 0 1-.278-.078.2.2 0 0 1 .078-.276l.49-.277-.858-.487a.212.212 0 0 1-.078-.287c.056-.1.19-.133.29-.078l.434.255-.456-.731a.211.211 0 0 1 .067-.287c.1-.067.222-.034.29.066l.467.73-.033-.509ZM91.432 113.939c-.011-.11.078-.21.189-.221a.21.21 0 0 1 .223.188l.067 1.007.59-.343a.204.204 0 1 1 .2.354l-.567.321.858.487c.1.055.133.188.078.287a.216.216 0 0 1-.29.078l-.435-.255.457.73c.067.1.034.222-.067.288a.216.216 0 0 1-.29-.066l-.467-.73.033.508a.21.21 0 0 1-.19.222.21.21 0 0 1-.222-.188l-.067-1.007-.513.299a.203.203 0 0 1-.278-.078.201.201 0 0 1 .078-.277l.49-.276-.858-.487a.213.213 0 0 1-.078-.288.217.217 0 0 1 .29-.077l.434.254-.456-.73c-.067-.099-.034-.221.066-.288.1-.066.223-.033.29.067l.468.73-.033-.509ZM95.71 116.351c-.01-.11.078-.21.19-.221a.21.21 0 0 1 .223.188l.067 1.007.59-.343a.203.203 0 0 1 .279.078.2.2 0 0 1-.078.276l-.569.321.858.487c.1.055.134.188.078.288a.217.217 0 0 1-.29.077l-.434-.254.457.73a.211.211 0 0 1-.067.287c-.1.067-.223.034-.29-.066l-.468-.73.034.509c.011.11-.078.21-.19.221a.209.209 0 0 1-.222-.188l-.067-1.007-.513.299a.203.203 0 0 1-.278-.078.2.2 0 0 1 .078-.276l.49-.277-.858-.487a.212.212 0 0 1-.078-.287c.056-.1.19-.133.29-.078l.434.255-.457-.731c-.067-.099-.033-.221.067-.287a.215.215 0 0 1 .29.066l.468.73-.034-.509Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#6BB6FF",
    d: "M88.557 49.589c0-.432.078-.797.212-1.107.167-.365.412-.652.724-.852a1.77 1.77 0 0 1 1.148-.254c.357.033.735.155 1.137.376l2.752 1.56.09.122a14.875 14.875 0 0 0 1.77 1.936 11.472 11.472 0 0 0 1.884 1.394c.635.365 1.226.598 1.772.72.523.11.991.11 1.393.01l.289-.077c.39.221 1.961 1.051 2.117 1.206.691.398 1.315 1.073 1.761 1.837.446.763.713 1.637.713 2.423l-.011 5.466c.033 1.471-.011 2.235-.735 2.555-.624.266-1.382-.1-2.764-.907a2428.8 2428.8 0 0 0-5.883-3.419 665.183 665.183 0 0 0-5.895-3.396l-.267-.155c-2.106-1.206-2.24-1.273-2.24-4.017l.033-5.421Zm1.572-.52c-.056.133-.09.31-.09.52l-.01 5.432c0 1.881.088 1.937 1.492 2.733l.268.155c2.284 1.306 4.2 2.412 5.906 3.397 1.392.808 3.498 2.036 5.883 3.43.947.553 1.415.83 1.426.83.101-.044-.122-.365-.145-1.173l.012-5.51c0-.531-.201-1.15-.513-1.693-.323-.553-.747-1.018-1.226-1.295l-1.615-.918a4.767 4.767 0 0 1-1.761-.055c-.69-.144-1.426-.443-2.206-.885-.736-.42-1.46-.963-2.14-1.583a15.2 15.2 0 0 1-1.85-2.013l-2.507-1.417a1.26 1.26 0 0 0-.523-.188c-.1-.01-.19 0-.246.045a.457.457 0 0 0-.156.188Zm8.156 3.01c1.204.851 2.106.973 2.875.796a2.97 2.97 0 0 0 1.359-.42 2.93 2.93 0 0 0 .981-1.008c.39-.674.579-1.582.513-2.655-.112-1.638-.814-3.44-1.85-5.056-1.036-1.605-2.407-3.02-3.889-3.873-1.047-.597-2.028-.852-2.875-.797a2.97 2.97 0 0 0-1.36.42 2.938 2.938 0 0 0-.98 1.008c-.39.675-.58 1.582-.513 2.655.112 1.638.814 3.441 1.85 5.057 1.025 1.604 2.407 3.02 3.89 3.872Zm-2.64-4.659c.913 1.416 2.105 2.656 3.387 3.386.78.442 1.471.642 2.039.597.256-.022.479-.088.68-.199.189-.11.345-.276.468-.498.245-.431.367-1.04.312-1.825-.101-1.383-.702-2.955-1.616-4.36-.914-1.416-2.106-2.655-3.388-3.386-.78-.453-1.47-.641-2.039-.597a1.68 1.68 0 0 0-.68.2c-.189.11-.345.276-.468.497-.245.432-.367 1.04-.312 1.826.09 1.383.703 2.954 1.616 4.36Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m110.453 46.513 1.85-1.051 13.449 36.634-.067 15.623-2.128.797a1274.84 1274.84 0 0 0-11.221-6.45c-1.014-.587-1.838-2.004-1.838-3.165l-.045-42.388Z",
    opacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4FF",
    d: "m110.687 45.65.847-.442c.301-.1.668-.045 1.081.188 10.129 5.764 20.235 11.739 30.364 17.503.958.543 1.727 1.881 1.727 2.966l.045 39.809c0 .498-.167.852-.424 1.052-.323.232-.98.741-1.493.442-10.129-5.764-20.046-12.248-30.175-18.024-.958-.553-1.727-1.88-1.727-2.965l-.245-40.529Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.164 46.756c0-1.084.78-1.526 1.738-.984 10.129 5.764 20.235 11.739 30.364 17.504.959.542 1.727 1.88 1.727 2.965l.045 39.81c0 1.084-.78 1.526-1.738.984-10.129-5.764-20.236-11.74-30.365-17.504-.958-.553-1.727-1.88-1.727-2.965l-.044-39.81Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M110.164 46.756c0-1.084.78-1.526 1.738-.984 10.129 5.764 20.235 11.739 30.364 17.504.959.542 1.727 1.88 1.727 2.965l.034 31.279-33.819-19.252-.044-31.512Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#A67EF6",
    d: "M112.682 82.472c0-.475.334-.652.746-.409l9.327 5.233c.412.244.746.82.746 1.295v.93c0 .475-.334.652-.746.409l-9.327-5.234c-.412-.243-.746-.819-.746-1.294v-.93ZM112.682 86.555c0-.41.301-.575.657-.365 5.293 2.965 13.951 7.811 19.244 10.777.368.21.657.73.657 1.14v.818c0 .41-.301.575-.657.365-5.293-2.965-13.951-7.811-19.244-10.777-.368-.21-.657-.73-.657-1.14v-.818Z",
    opacity: 0.25
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M139.202 64.98c1.348.354 2.552 1.936 2.697 3.54.145 1.605-.836 2.611-2.184 2.257-1.349-.354-2.552-1.936-2.697-3.54-.145-1.605.836-2.611 2.184-2.257Z",
    opacity: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M139.325 66.407c.68.177 1.292.984 1.37 1.792.067.808-.423 1.328-1.114 1.14-.68-.177-1.292-.985-1.37-1.793-.067-.807.434-1.316 1.114-1.14ZM113.729 72.935c-.546-1.682-1.95-5.057-2.106-6.816-.156-1.792.936-2.92 2.452-2.534 1.515.399 2.863 2.169 3.019 3.961.179 1.926-2.128 3.906-3.365 5.389Zm.335-8.11c-.914-.244-1.572.442-1.482 1.526.089 1.085.902 2.147 1.816 2.39.914.244 1.571-.442 1.471-1.526-.089-1.085-.903-2.158-1.805-2.39ZM113.462 74.96c-.212.276.211.641.457.332.222-.3.445-.61.668-.908.223-.287-.223-.641-.457-.343-.223.31-.445.609-.668.919Zm25.55-5.245c.034-.387-.534-.42-.568-.066-.044.354-.111.73-.189 1.084-.089.332.445.509.557.133.078-.388.156-.775.2-1.151Zm-.757 2.8c.133-.344-.346-.565-.524-.222a7.225 7.225 0 0 1-.501.963c-.201.332.3.608.479.298.211-.332.39-.686.546-1.04Zm-1.672 2.4c.29-.287-.145-.653-.379-.42a3.945 3.945 0 0 1-.869.608c-.323.166-.078.675.268.498.367-.177.679-.41.98-.686Zm-2.752 1.14c.379 0 .379-.564 0-.564-.279 0-.78-.056-1.036-.166-.368-.1-.524.41-.179.542a4.16 4.16 0 0 0 1.215.188Zm-2.786-1.007c.279.21.647-.21.335-.454-.29-.21-.58-.453-.836-.708-.256-.254-.669.133-.401.399.278.276.579.53.902.763Zm-2.05-2.058c.234.299.68-.055.457-.343a25.507 25.507 0 0 1-.646-.907c-.212-.321-.68 0-.48.31.201.32.435.63.669.94Zm-1.56-2.4c.189.32.68.032.49-.289a7.304 7.304 0 0 0-.657-.962c-.223-.288-.68.055-.446.354.212.299.412.564.613.896Zm-1.772-2.037c.312.2.635-.221.323-.464a4.886 4.886 0 0 0-1.058-.576c-.357-.133-.546.41-.201.531.346.133.647.31.936.51Zm-2.485-.73c.402-.033.312-.597-.033-.564a5.383 5.383 0 0 0-1.181.199c-.357.1-.212.642.156.542a4.24 4.24 0 0 1 1.058-.177Zm-2.574.808c.324-.188.067-.664-.278-.498a11.31 11.31 0 0 0-.992.62c-.301.232.022.663.323.464.312-.21.635-.42.947-.586Zm-2.239 1.615c.267-.265-.078-.653-.379-.42-.29.254-.568.52-.847.785-.268.266.134.664.401.399.268-.266.546-.52.825-.764Zm-1.984 1.97c.234-.266-.145-.653-.423-.377-.257.288-.502.576-.747.863-.245.31.223.642.435.365.245-.287.479-.575.735-.851Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M113.25 73.886c.658.177 1.248.952 1.315 1.726.067.786-.412 1.273-1.07 1.107-.657-.177-1.248-.952-1.314-1.726-.067-.786.412-1.273 1.069-1.107Z",
    opacity: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M113.306 74.583c.334.089.635.476.668.874.034.399-.211.642-.546.565-.334-.089-.635-.476-.668-.875-.023-.398.211-.652.546-.564Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M72.2 13.851c3.03 1.76 6.073 3.507 9.104 5.233.925.532 1.682 1.826 1.682 2.888l.045 38.715c0 1.062-.758 1.482-1.694.951l-12.112-6.981-.022-9.571L72.2 13.85Z",
    opacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4FF",
    d: "m50.292 2.222.77-.41c.267-.088.612-.044.98.178C61.29 7.256 70.517 12.71 79.766 17.978c.869.498 1.582 1.715 1.57 2.71l.045 36.358c0 .454-.145.786-.39.963-.29.21-.891.675-1.37.41-9.249-5.267-18.308-11.187-27.557-16.453-.869-.498-1.582-1.715-1.57-2.711l-.202-37.033Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.825 3.229c0-.996.713-1.394 1.582-.896 9.249 5.266 18.475 10.721 27.724 15.988.869.498 1.582 1.715 1.57 2.71l.045 36.358c0 .996-.713 1.394-1.582.896-9.249-5.266-18.475-10.72-27.724-15.988-.869-.497-1.582-1.715-1.57-2.71l-.045-36.358Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M49.825 3.229c0-.996.713-1.394 1.582-.896 9.249 5.266 18.475 10.721 27.724 15.988.869.498 1.582 1.715 1.57 2.71l.034 28.569-30.888-17.593-.022-28.778Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#F786DC",
    d: "M52.12 35.847c0-.431.312-.597.68-.376l8.513 4.78c.379.221.68.752.68 1.184v.852c0 .431-.312.597-.68.376l-8.513-4.78c-.379-.221-.68-.752-.68-1.184v-.852ZM52.12 39.576c0-.377.268-.531.602-.332 4.825 2.71 12.747 7.136 17.572 9.847.335.2.602.664.602 1.04v.752c0 .377-.267.532-.602.332-4.825-2.71-12.747-7.136-17.572-9.847-.334-.2-.602-.664-.602-1.04v-.752Z",
    opacity: 0.25
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#F786DC",
    d: "m74.061 26.63-.033 18.068 5.103 2.955.034-18.069-5.104-2.954ZM58.728 12.258l-.055 24.175 5.103 2.955.056-24.176-5.104-2.954Zm7.656 8.575L66.35 40.87l5.093 2.965.033-20.037-5.092-2.965ZM51.05 13.95l-.033 18.069 5.103 2.954.033-18.068-5.103-2.955Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#955CF1",
    d: "M50.995 21.02a.296.296 0 0 1 .022-.464.438.438 0 0 1 .546.022l4.836 4.503 2.34.996 5.025-1.018 3.053-3.32a.44.44 0 0 1 .547-.055c.033.023.066.045.089.078l7.165 7.645 4.368 1.074c.211-.011.39.132.4.31.012.177-.155.331-.367.343l-4.557-1.063a.421.421 0 0 1-.335-.121l-6.998-7.458-2.83 3.076a.444.444 0 0 1-.212.122l-5.292 1.073a.404.404 0 0 1-.257-.022l-2.507-1.062a.385.385 0 0 1-.133-.078l-4.903-4.58Z",
    opacity: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.995 21.12a.382.382 0 0 1 .022-.542.389.389 0 0 1 .546.022l4.836 5.278 2.34 1.162 5.025-1.195 3.053-3.895a.392.392 0 0 1 .547-.066.337.337 0 0 1 .089.088l6.797 8.708 4.802-.177a.384.384 0 0 1 .402.365.384.384 0 0 1-.368.398l-4.981.188a.406.406 0 0 1-.334-.143l-6.63-8.498-2.83 3.607c-.056.066-.123.122-.212.133l-5.293 1.261a.343.343 0 0 1-.256-.033l-2.508-1.25a.305.305 0 0 1-.133-.1l-4.914-5.31Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEEAE4",
    d: "m1.888 120.235 19.767-11.186c2.151-.974 5.238-1.759 7.433-.62 2.006 1.029 5.293 3.154 6.752 3.972 1.104.631 4.948 2.91 2.552 4.205-7.042 3.806-14.007 8.077-21.16 11.938-1.348.731-3.332.996-5.404.819-2.073-.166-4.19-.763-5.862-1.737-1.192-.686-2.35-1.361-3.51-2.025-1.549-.896-2.373-1.958-2.451-2.932-.067-.951.557-1.836 1.883-2.434Z",
    opacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M28.174 67.69c.09.852-.044 2.169.023 5.389.044 2.279-.257 6.262-.502 9.68-.1 1.417-.3 2.667-.423 3.774-.09.796-.446 1.593-.557 2.368-.87 5.853-1.995 11.175-2.663 18.256-.156 1.626-.324 2.467-.034 4.083.056.309.212.63.256.951.201 1.56.357 3.12.97 4.415.089.188.223.686.334.896 0 0-1.404.487-1.582.509-.167.022-2.44-.608-2.44-.608s-.847-3.762-.836-3.984c.145-2.467-1.571-2.013-.045-3.883.145-.233.112-.255.1-.531-.022-2.434-.434-5.975-.746-9.15-.892-9.051.624-8.398.97-12.725-.625-5.2-1.895-12.59-1.761-18.997l8.936-.443Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#273087",
    d: "M24.931 115.909c.245.443.513 1.084.736 1.56.29.62.434 1.029.568 1.516.067.243.056.476-.056.609-.546.73-3.298-.598-4.212-1.406-.59-.52-.601-1.139-.746-1.892-.212-1.128-.245-1.261-.524-2.423l-.312 3.154-.268.155c-.055-1.284-.189-2.988-.39-4.083-.078-.443-.211-.941-.233-1.184-.112-1.427.601-2.136 1.247-2.534-.245.863.39 2.279.68 4.061.301 1.859 1.337 3.894 2.15 4.071.346.078 1.104-.354 1.516-.586.19-.077.011-.609-.156-1.018Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M17.053 64.969c-.936 3.009-2.785 5.753-3.153 8.12-.368 2.38-.167 4.626.29 8.177.312 2.412 1.549 7.856 1.281 9.925-.39 3.02-1.493 4.813-1.86 8.354-.302 2.854.178 6.992.322 10.931.056 1.505-.078 1.527-.434 2.877-.112.421-.19.885-.256 1.405a20.715 20.715 0 0 0-.1 4.271c.044.598.267.896.334 1.715l3.376 1.073a42.6 42.6 0 0 1-.223-3.009c-.044-1.073-.033-2.235-.022-3.308 0-1.527-.145-2.49.122-3.939.914-4.813 2.318-9.04 3.276-13.001.502-2.069.647-3.906 1.382-6.86.301-1.206.546-2.412.613-3.651.19-3.286.825-7.236.847-10.61 2.73-3.94 4.513-5.876 5.26-7.923.144-1.339-.324-2.943-.324-2.943l-10.73-1.604Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#273087",
    d: "M13.822 112.191c-.29.664-.568 1.007-.724 1.948-.156.94.09 2.467-.1 3.64l-.301 1.848c-.178 1.073 0 1.859 1.125 2.91 1.014.951 2.062 1.427 2.697 1.217.468-.155.914-.874.513-2.977-.335-1.748-.324-3.407-.413-5.277-.122 1.803-.167 2.423.045 4.237.055.509.089 1.328-.513 1.328-2.473.033-2.507-.631-2.607-1.405-.29-2.058-.212-5.643.278-7.469Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M17.053 64.969c-.936 3.009-2.785 5.753-3.153 8.12-.546 3.541.078 6.352 1.047 14.064.123 1.006-.022 1.958-.211 2.832-.58 2.689 2.083 3.43 5.237 2.445 3.855-1.217 7.41-4.071 7.644-5.4.434-3.761 1.504-10.92 1.437-14.14-.067-3.22-.802-4.326-.891-5.189l-.034-.83c-.1-.674-9.705-1.692-11.076-1.902Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M10.212 49.202c7.076 3.784 10.04-3.452 10.775-8.896.312-2.346.234-4.592-.791-5.997-1.07-1.471-2.875-2.069-4.636-2.002-3.822.143-5.872 3.75-4.958 7.523.902 3.674 2.685 7.668-.39 9.372Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58C7E",
    d: "M19.56 34.475c-1.927-.985-4.701 1.228-3.799 4.248.3-1.593 1.237-3.352 3.8-4.248Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M19.338 34.22c6.786-2.235 11.633 8.177 3.867 11.408-7.433 3.087-11.41-8.93-3.867-11.407Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M45.936 52.908c.4.576-.357.985-.691.996-.546.066-1.315-.21-1.516.155-.211.41-2.763-.431-2.73-.454 1.048-.752 2.006-.93 2.173-.918 1.627.11 1.148.476 2.764.221Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M41.356 55.962c-2.34.653-5.526 2.92-7.755 3.419-.702.155-1.794.464-2.351-.133-2.864-3.065 1.114-2.058 1.448-3.22 2.028-1.505 5.215-.797 7.823-2.19.178-.111.345-.21.512-.3 1.025-.508 1.594-.464 3.365.421.513.255.78.221 1.237.21l1.783-.232c.546-.022.892.11.98.288.09.199-.1 1.316-.423 1.759-.067.21-.468.365-1.103.376l-2.607.797-.123-.067c-1.56-.863-2.217-1.161-2.786-1.128Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M30.258 59.525c-2.106-1.948-5.092-4.78-6.162-7.026-.69-1.46-.825-5.543 1.415-6.064.747-.464 1.894 2.579 2.652 3.807 1.382 2.224 2.418 3.551 4.045 5.598 1.727-1.117 4.123-1.228 6.363-1.781.367-.089.702-.1 1.036-.033a3.81 3.81 0 0 0 .78-.266c.256.067 1.103 1.516.958 2.368-.178.055-.58.166-.758.232-.267.089-.412.343-.68.487-.89.476-4.913 2.468-6.908 2.91-.758.166-1.983.564-2.585-.077a.687.687 0 0 1-.156-.155Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#F969AC",
    d: "M30.258 59.525a78.025 78.025 0 0 1-2.284-2.18c1.66-1.438 1.504-3.994.434-5.554-.702-1.018-1.114-1.76-1.47-2.567-.112-.62-.212-1.129-.324-1.472a1.869 1.869 0 0 0-.245-.575c.346.431.546 1.272 1.103 2.445.959 2.014 2.418 3.198 2.54 5.565.09 1.749.892 3.818 2.207 4.747-.657.133-1.393.2-1.816-.255a.955.955 0 0 1-.145-.154Z",
    opacity: 0.35
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M15.65 61.86c1.292 2.976-.914 4.635-.112 6.682l-.245 1.394c2.362 1.693 10.83 1.815 12.96-1.538l.044-1.67c.367-.797.122-2.822.022-3.353-.345-1.693-.178-2.589-.368-4.547-.044-.498-.145-.808-.19-1.306 1.884-1.394 1.773-4.105.647-5.731-.702-1.018-1.114-1.76-1.47-2.567-.112-.62-.212-1.129-.324-1.472-.067-.287-.223-.564-.39-.807-.535-.764-1.404-.852-3.187-.454-3.52.808-7.153 2.622-8.77 4.326-1.18 1.25-1.125 2.622-.456 5.61.434 1.936 1.181 3.917 1.838 5.432Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#F969AC",
    d: "M15.627 61.848c1.293 2.976-.858 4.68-.055 6.738l-.245 1.372c2.362 1.826 10.83 1.749 12.959-1.604l-.045-1.46c0-.056-4.156 3.662-8.892 1.593-1.025-.454-1.961-2.678-.624-6.949.123-.41 1.638-.431 3.766-1.991-1.582.664-4.546 1.57-4.702-2.412-.067-1.782-.334-3.12-1.248-4.36-.446-.597-3.053 2.545-2.663 4.06a38.506 38.506 0 0 0 1.75 5.013Z",
    opacity: 0.35
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7B7B",
    d: "M24.932 47.752c.29.952.445 5.62-.1 7.69-1.895-2.124-7.41-4.89-6.709-6.384.88-1.859 6.296-2.954 6.809-1.306Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M24.653 47.962c.256.852.345 5.079-.022 6.905-1.45-1.726-6.775-4.349-6.13-5.831.736-1.682 5.695-2.556 6.152-1.074Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M19.795 44.012c.267 1.538.133 2.999-.357 4.492 1.27 1.162 3.532.675 4.056-.387-.111-.686-.245-1.317-.312-2.014l-3.387-2.09Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M19.794 44.012c.134.742.168 1.46.112 2.169.368 1.494 3.187 2.5 3.477 1.317-.078-.465-.156-.908-.212-1.395l-3.377-2.09Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M25.032 37.496c.635.995.97 2.002.824 3.418-.033.366.011.587.123.82.59 1.327.535 1.736.245 2.799-.29 1.029-.267 1.57-.624 1.925-.368.365-.914.453-1.37.476-.948.055-2.575-.565-3.522-1.074-.702-.376-.668-.641-.97-1.305-.99-.852-.345-1.483-.021-1.538.947-.188 1.103.907 1.671 1.15-.09-1.914 3.577-5.133 3.644-6.671Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M25.455 38.259c.357.763.513 1.593.402 2.655-.034.365.01.587.122.819.59 1.328.535 1.737.245 2.8-.122.464-.19.83-.256 1.117a.896.896 0 0 1-1.103.32c-.401-.176-.78-.641-.88-1.416-.067-.553-1.204-.907-1.438-1.471-.19-.465.334-.985.646-1.25 1.104-.93 1.794-2.202 2.262-3.574Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F7F",
    d: "M25.031 37.496c-.534 2.345-3.621 4.127-3.643 6.671.847-2.644 3.844-4.459 3.643-6.671Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M14.1 67.801c.424.254 1.182.498 1.494.686.156.1 1.304.797 1.939 1.228.69.454.88 1.118 1.292 1.859.29.597.424 1.029.457 1.328.045.31-.746.907-1.08.83-.77-.166-1.55-1.096-1.75-1.207-1.716-.885-2.53-.973-3.154-1.67-.267-.299-.423-1.173-.969-1.959l1.047-.94.725-.155Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M14.1 50.817c-2.774 1.15-5.148 6.539-7.666 9.759-.501.63-.512 1.261-.245 1.737.1.254.267.542.49.885 1.193 1.748 2.173 3.23 4.736 5.4.19.165.368.232.658.31.155.132.39.364.557.508-.212-.276 1.058-1.637 1.638-1.538-.145-.177-.301-.376-.457-.586-.022-.266-.034-.343-.167-.542-1.07-1.538-2.106-3.585-3.432-5.024 2.24-1.803 3.588-3.031 5.437-5.266 2.597-3.165.569-6.528-1.548-5.643Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEEAE4",
    d: "M29.322 151.636c8.023-4.603 20.993-4.603 28.971 0 7.979 4.603 7.934 12.071-.089 16.663-8.023 4.603-20.993 4.603-28.971 0-7.968-4.603-7.934-12.071.089-16.663Z",
    opacity: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0FFFD",
    d: "M88.836 154.148 67.743 142.22c-2.296-1.04-5.594-1.87-7.934-.664-2.14 1.107-5.65 3.364-7.21 4.238-1.18.664-5.281 3.109-2.73 4.492 7.51 4.061 14.954 8.619 22.576 12.735 1.448.775 3.554 1.063 5.772.874 2.206-.177 4.468-.818 6.251-1.847 1.27-.731 2.518-1.45 3.744-2.158 1.66-.951 2.53-2.091 2.619-3.131.078-1.029-.58-1.981-1.995-2.611Z",
    opacity: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#8141E7",
    d: "m59.787 158.153.033 1.571c.011 2.379-1.571 4.758-4.736 6.561-5.036 2.899-12.28 3.353-17.962 1.881-3.755-.974-9.371-3.762-9.371-8.354l-.034-1.571 32.07-.088Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M32.453 151.68c6.285-3.596 16.436-3.596 22.676 0 6.251 3.607 6.218 9.449-.067 13.045-6.284 3.596-16.436 3.596-22.687 0-6.24-3.607-6.206-9.449.078-13.045Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#8141E7",
    d: "M45.446 119.527v37.508c0 .288-.19.587-.58.808-.624.354-1.504.41-2.206.233-.457-.122-1.148-.465-1.148-1.029v-37.509l3.934-.011Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M64.31 127.25c-1.938 4.935-2.997 11.905-4.167 17.338-.178.642-.513 1.449-1.382 1.892-1.37.697-2.897.553-3.276-.465.034-5.078-.278-8.829-.122-11.617.178-3.121 1.36-7.878 2.563-9.693.891-4.215 8.446-2.6 6.385 2.545Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2353",
    d: "M64.51 126.664c-.066.221-.133.42-.2.586l-.078.21-.022.045a36.95 36.95 0 0 0-.902 2.71l-.012.045-.066.232-.023.077-.044.166c-1.27 4.481-2.162 9.803-3.087 14.063-.48-6.384.58-12.779 2.284-18.3.1-1.483.045-2.8-.1-4.006 1.593.476 2.864 1.948 2.25 4.172Z",
    opacity: 0.3
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.96 149.312c-.892.863-1.427.31-1.795 1.87-.97 1.461-1.85 1.914-2.652 1.749-1.025-.211-1.816-.62-1.96-1.749-.168-1.881-.213-2.235.289-3.618l.134-.088c.111-.122.234-.166.412-.122.891.21 1.159.752 1.482 1.062.69.653 1.36.133 1.649-.63v-.012l.011-.022v-.011l.011-.033v-.011l.011-.044v-.011l.012-.045v-.066l.01-.077.012-.078v-.011c.011-.044.011-.088.022-.133v-.011l.011-.055v-.1l.011-.088v-.233c0-.044-.01-.077-.022-.121-.022-.31 0-.52.045-.664 0-.078.01-.144.01-.221.97-.543 2.43-2.003 3.466-2.28.747-.199 1.16.852 1.193 1.339.089 1.173-1.404 3.485-2.363 4.514Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA495",
    d: "M59.44 145.396c-.044 1.062.046 2.235-.746 2.854-.69.543-1.883.753-2.607-.332-.301-.453-.268-1.25-.379-2.212-.011.708 3.789.431 3.733-.31Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#193161",
    d: "M61.725 148.859c-.892.863-1.426.31-1.794 1.87-.97 1.46-1.85 1.914-2.652 1.748-1.014-.21-1.816-.62-1.961-1.748-.167-1.881-.212-2.235.29-3.618l.133-.089c.112-.122.234-.166.413-.122.89.211 1.158.753 1.481 1.063.691.652 1.36.132 1.65-.631v-.011l.01-.022v-.011l.012-.033v-.012l.011-.044v-.011l.011-.044v-.067l.011-.077.011-.077v-.011c.012-.045.012-.089.023-.133v-.011l.01-.056v-.099l.012-.089v-.232c0-.044-.011-.078-.022-.122-.023-.31 0-.52.044-.664 0-.077.011-.143.011-.221.97-.542 2.396-1.593 3.432-1.87.747-.199 1.193.443 1.215.93.09 1.172-1.404 3.485-2.351 4.514Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.13 143.681c.256.288.846.1 1.125.741.01-.42-.424-1.029-.88-1.029-.09 0-.368.166-.246.288Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M60.355 143.581c-.067.332-.145.664-.212.996-.178.642-.512 1.449-1.381 1.892-1.37.697-2.897.553-3.276-.465 0-.442-.078-.874-.078-1.294.757.94 3.343 1.504 4.947-1.129Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#161D5C",
    d: "M45.278 120.888c-4.3-1.195-12.513 3.353-20.28 11.607-7.009 7.446 19.768 15.28 25.083 13.266 5.059-1.925 17.884-8.287 16.803-10.976-2.106-5.245-13.828-11.739-21.606-13.897Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M48.733 121.63c-3.833.121-8.135-.011-11.556 1.239-3.187 1.162-2.685 5.742.223 8.376 2.552 2.301 6.853 2.987 13.216.398 1.972-.808 3.866-1.549 6.82-1.892 2.84-.321 4.702.254 6.261-2.412 1.115-1.892.77-4.116-1.86-4.968-3.845-1.25-9.16-.874-13.104-.741Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA495",
    d: "M83.064 144.323c1.07 1.903 1.582 2.644 1.86 3.042.625.908-.69 2.39-1.56 2.866-.88.476-2.273.487-2.874-.874-.234-.531-.312-1.239-.569-1.903.435.708 2.374-1.394 3.143-3.131Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.748 150.12c.446-.11 3.12.841 3.243-2.511 1.916.465 5.014-1.029 6.764-1.007.312 0 .835-.343.991-.166.502.542 1.059 1.405.324 2.224-.535.597-1.783 1.505-2.608 2.025-.88.553-2.407 1.46-3.465 1.881-1.182.464-1.716.664-2.095 1.117-.58.476-1.215.764-1.605.786-.836.055-1.872-.199-2.518-1.018-.2-.255-.502-1.527-.535-2.39-.022-.675.167-1.505.29-2.257l1.214 1.316Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#193161",
    d: "M85.403 147.188c1.059.067 3.744-.741 5.505-.995.758-.111 1.426-.266 1.916.332.457.542.413 1.106-.189 1.781-.535.597-1.515 1.361-2.34 1.881-.88.553-2.407 1.46-3.465 1.881-1.17.464-1.716.664-2.095 1.117-.58.476-1.215.764-1.605.797-.836.055-1.894-.299-2.54-1.107-.201-.254-.48-1.438-.513-2.29-.022-.476-.078-1.195-.056-1.615.045-.697.335-.808.669-.708.624.177.958.675 1.27 1.073.268.343.59.52.914.542.713.055 1.226-.443 1.493-1.095.134-.432.156-.908.156-1.406l-.033-.132c-.134-1.162.445-1.184.412-.93 0 .21.145.708.501.874Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.312 146.436c.09.442.68 0 .88 1.106.38-.531-.222-1.228-.657-1.361-.1-.022-.312-.077-.223.255Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M70.918 126.199c3.075 5.211 8.77 12.99 11.945 17.648.814 1.515-.557 3.85-3.075 4.182-3.6-4.271-7.8-6.683-11.355-11.95-.668-.995-1.916-3.098-2.696-4.613-.97.121-2.285.32-3.711.553-2.942.476-5.37 1.162-7.299 2.08-6.195 2.954-10.54 2.523-13.215.365-3.053-2.456-3.822-6.993-.702-8.343 3.343-1.438 7.154-1.748 10.965-2.091 3.487-.309 10.452-.984 14.708-.42.334.044.646.099.947.155 1.137.199 1.906.476 2.753 1.35.334.332.58.697.735 1.084Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M82.462 142.928c.178.299.846 1.262 1.025 1.549.468 1.262-1.226 3.408-3.755 3.607-.19-.254-.892-1.006-1.092-1.25 2.273-.642 3.721-1.914 3.822-3.906Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M44.554 100.563c.669-1.14 1.337-2.091 2.073-3.12.601-.841.802-.82 1.738-1.074 1.025-.287 1.237-.21 2.15.056.792.232 1.46.796 1.661 1.15.635 1.129-1.995 1.372-2.218 1.472-.423.819-.545 1.46-1.303 1.925-1.27.775-1.783.797-2.251 1.715l-1.85-2.124Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9281",
    d: "M47.362 99.07c.813-.941.869-1.163 1.927-2.037.045-.022.09-.033.123-.044l.914.055c.446.465 1.237.93 1.76.41l.067.1c.38.586 0 1.36-.345 1.415-.836.122-1.482-.055-1.839.1-.423.819-.546 1.461-1.303 1.925-1.27.775-1.783.797-2.251 1.715l-1.17-1.35 2.117-2.29Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M39.417 111.926c.825-1.151 5.237-5.776 6.318-7.668.156-.277.234-.94.234-1.062l.591-.764c-.111-.907-1.114-1.958-2.006-2.08l-.646.52c-.435-.022-1.126.122-1.504.343-2.976 1.726-8.313 6.617-8.29 10.124.033 2.423 4.156 1.605 5.303.587Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "m52.187 92.685-7.744 12.27 12.58 3.076 7.756-12.259-12.592-3.087Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M46.081 101.359c1.772.166 1.482-.84 2.106-2.002.312-.144.546-.41.847-.664 1.214-.2 1.36-.752 1.203-1.328-.412.011-1.214.011-1.56.044-1.66.709-2.897.753-3.621 2.578-.256.664.501.554 1.025 1.372Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.761 106.781a.338.338 0 0 0 .646.199c.246-.763.591-2.412.591-3.74-.01-.973-.211-1.792-.769-2.113-.947-.52-1.56-.133-2.172.266-.112.066-.223.143-.312.188-.257.143-.468.221-.636.232a.531.531 0 0 1-.445-.177c-.134-.144-.223-.365-.29-.62a3.87 3.87 0 0 1 0-1.56c.056-.254.111-.509.178-.763.335-1.405.658-2.744-.613-3.275a.338.338 0 0 0-.434.177.334.334 0 0 0 .178.431c.736.31.48 1.383.212 2.5-.067.266-.134.532-.178.797-.112.554-.134 1.251 0 1.837.078.365.222.686.445.93.245.265.569.42.98.387.28-.011.58-.111.937-.31.122-.077.234-.144.334-.21.446-.288.892-.576 1.482-.244.312.177.424.786.435 1.538 0 1.251-.335 2.8-.569 3.53Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "m34.849 123.931.245 1.051c2.028 3.242 9.683 5.388 15.11.73-.123-.52-.201-.874-.246-1.339.123-.365.112-.951.034-1.792-.212-2.069-.98-5.687-.992-5.864-.245-4.57.769-9.106-1.27-12.348-.435-.697-1.025-.963-1.694-1.328-1.47-.774-8.068-2.799-11.488-3.286-2.062-.299-4.324.088-5.06 2.456-1.002 3.22 1.093 7.989 2.809 12.492 2.262 5.886 1.226 6.793 2.552 9.228Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#3469C0",
    d: "M50.026 122.935c-.012-.111-.023-.233-.034-.354-.212-2.069-.98-5.687-.992-5.864-.245-4.57.903-9.195-1.27-12.348-1.27-1.848-4.045-1.527-5.025.752-.747 1.726-.067 4.205.835 8.298.647 2.899 1.794 9.693 3.521 10.401.602.243 1.605-.066 2.965-.885Z",
    opacity: 0.35
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M40.008 96.779c.122 1.106.479 2.655.88 3.717-2.262.343-5.505.343-6.162-1.25l-.134-3.153c1.805-2.136 5.316.708 5.416.686Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A9FF8",
    d: "M34.693 99.19c-.624.333-1.126 1.129-.914 1.539 1.17 2.567 6.307 2.412 9.27 1.195-.412-.675-1.504-1.538-2.128-1.616-1.916.553-5.326.365-6.228-1.117Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M39.696 98.903c-.68-.155-1.07-.974-1.304-2.357-.212-1.172-3.543.31-3.488.233-.3-1.073-1.348-1.881-1.582-3.364-.334-2.08.178-4.27 2.262-5.51 3.789-2.257 7.923.255 8.502 4.349.111.796-.557 1.14-.624 1.803-.011.133.145.288.245.597.145.42-.267 3.065-1.025 4.094-.323.42-2.474.365-2.986.155Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M42.682 98.748c-.134.188-1.103-.022-1.46-.188 1.527-1.903-.234-3.441 1.326-5.255.936-1.085-.033-2.302 1.014-2.877.257.564.446 1.173.535 1.825.111.797-.557 1.14-.624 1.804-.011.133.145.287.245.597.123.42-.312 3.043-1.036 4.094Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB49C",
    d: "M40.532 96.248c.256-.487.122-.686-.112-.664-.256.022-.646.332-.903.83-.4.807-.133 1.936.747 1.626-.713-.055-.535-.885-.256-1.383.2-.343.457-.564.523-.41Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D8E",
    d: "M40.175 96.424c.145.388.19.62.111.73-.055.078-.2.166-.4-.077.021-.243.144-.476.289-.653Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#562E65",
    d: "M34.436 96.934c-.234-1.195-1.203-2.302-1.415-3.663-.212-1.338-.2-3.175 1.159-4.215.88-3.353 5.337-3.651 8.224-2.545 2.072.797 1.927 3.44.29 4.27.2 1.196-.458 2.203-.68 2.424-.658.708-.691.819-.814 1.571-.1.598-.312 2.058-.769.763-.3-.84-1.36-.066-1.616.775a3.892 3.892 0 0 1-.746 1.46c-1.114 1.383-3.499-.177-3.633-.84Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M35.84 88.325c1.103-3.087 5.55-2.213 6.976-1.372 1.437.852 1.08 3.862-1.092 3.596-1.493-.188-3.098-2.644-5.884-2.224Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9584",
    d: "m58.271 104.944 1.337-.155 1.181-.974.067-1.803-.97-.575c-1.013.121-1.604-.155-1.815.033-.234.21-.112 1.372.2 3.474Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M55.373 108.108c.235-.276.435-.553.591-.84-.044-1.085.245-1.771.724-2.412.78-1.052.892-1.195 1.059-1.981.067-.332.111-.575.167-.73.167-.41.646-.299.802.121.123.321.1.775.045 1.052l-.212.553 1.427-1.616c.234-.354-2.519.011-1.906-.818.346-.188.836-.222 1.415-.277a7.272 7.272 0 0 1 1.248.011c.569.044.791 2.368.803 2.976 0 .255 0 .686-.145.963-.335.708-.78 1.372-1.26 1.803-.924.819-1.76.72-2.462 2.269l-2.295-1.074Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#273087",
    d: "M62.572 100.308c-2.53 1.018-5.995 2.301-7.243 3.375 1.36-.011 4.97-1.627 7.51-2.667.636-.254.324-.94-.267-.708Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M56.689 104.845c.78-1.052.891-1.195 1.059-1.981.066-.332.111-.575.167-.73.167-.41.646-.299.802.122.123.32.1.774.044 1.051l-.256.885-1.816.653Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M50.515 112.534c1.337-1.759 2.842-3.695 3.744-4.492.245-.21.88-.431 1.003-.442l.624-.731c.925-.077 2.162.675 2.463 1.516l-.379.73c.111.421.111 1.118-.033 1.527-1.07 3.198-4.703 9.272-8.135 10.113-.356.1-.79.111-1.326 0-.635-.133-.902-.962-1.17-1.493-2.039-4.205-3.03-5.71-4.345-9.936-.87-2.789-.58-4.382.412-5.333 1.248-1.195 3.098-1.206 4.1.077 1.516 1.914 2.452 5.554 3.042 8.464Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "m64.221 139.631-9.538 6.262c-5.638 3.486-13.517 3.641-19.31.388l-10.765-6.052c-3.922-2.202-4.914-5.588-4.48-10.202.335-3.474 3.199-12.458 4.926-16.01 4.401-9.018 18.43.277 20.77 6.628 1.46 3.938 3.22 6.483 5.66 8.962 6.107 6.207 7.634.697 11.901-.797 3.979-1.394 4.224 3.087 4.034 6.528-.1 2.036-1.18 2.999-3.198 4.293Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "m64.221 139.631-9.538 6.263c-5.638 3.485-13.517 3.64-19.31.387l-10.765-6.052c-3.922-2.202-4.914-5.588-4.48-10.202.079-.785.28-1.837.569-3.054.97 1.206 14.842 13.3 25.317 14.096 6.53.487 13.193-1.549 21.416-5.72-.1 2.025-1.192 2.988-3.209 4.282Z",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 154.834,
    x2: 146.42,
    y1: 42.546,
    y2: 32.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 156.02,
    x2: 139.244,
    y1: 48.241,
    y2: 35.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 115.679,
    x2: 111.83,
    y1: 2.119,
    y2: 16.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 105.868,
    x2: 83.644,
    y1: 49.6,
    y2: 126.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 82.697,
    x2: 130.435,
    y1: 88.085,
    y2: 51.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 103.967,
    x2: 34.711,
    y1: 115.904,
    y2: 54.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 98.71,
    x2: 95.615,
    y1: 139.118,
    y2: 90.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 99.875,
    x2: 90.933,
    y1: 101.574,
    y2: 117.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 93.255,
    x2: 95.332,
    y1: 126.694,
    y2: 122.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 108.705,
    x2: 104.502,
    y1: 116.742,
    y2: 115.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 108.705,
    x2: 104.502,
    y1: 124.501,
    y2: 122.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 115.618,
    x2: 118.258,
    y1: 50.174,
    y2: 87.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D870AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58469C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 123.761,
    x2: 131.814,
    y1: 83.428,
    y2: 55.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 74.679,
    x2: 77.063,
    y1: 18.144,
    y2: 52.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D870AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58469C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 69.329,
    x2: 62.139,
    y1: 8.313,
    y2: 40.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 21.477,
    x2: 26.176,
    y1: 86.794,
    y2: 94.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 21.237,
    x2: 13.972,
    y1: 93.993,
    y2: 90.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 26.695,
    x2: 17.277,
    y1: 75.173,
    y2: 79.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 15.972,
    x2: 13.442,
    y1: 37.992,
    y2: 47.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2D68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22043D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 21.942,
    x2: 19.599,
    y1: 38.24,
    y2: 43.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2D68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22043D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 43.692,
    x2: 43.463,
    y1: 54.004,
    y2: 53.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 25.774,
    x2: 33.174,
    y1: 55.926,
    y2: 51.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA79B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 16.822,
    x2: 32.019,
    y1: 63.398,
    y2: 50.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA79B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 21.509,
    x2: 21.256,
    y1: 46.15,
    y2: 47.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 26.092,
    x2: 24.128,
    y1: 41.165,
    y2: 44.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 16.189,
    x2: 15.783,
    y1: 70.439,
    y2: 71.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 9.678,
    x2: 36.568,
    y1: 61.49,
    y2: 51.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA79B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 38.162,
    x2: 51.322,
    y1: 163.323,
    y2: 151.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 63.011,
    x2: 54.956,
    y1: 128.418,
    y2: 141.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 58.13,
    x2: 56.017,
    y1: 144.641,
    y2: 146.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 61.441,
    x2: 38.067,
    y1: 122.758,
    y2: 129.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 60.91,
    x2: 61.002,
    y1: 129.857,
    y2: 145.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 81.367,
    x2: 80.522,
    y1: 144.865,
    y2: 148.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 39.849,
    x2: 42.593,
    y1: 105.928,
    y2: 111.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 51.928,
    x2: 57.594,
    y1: 105.392,
    y2: 94.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 37.159,
    x2: 45.339,
    y1: 103.574,
    y2: 124.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 38.137,
    x2: 37.43,
    y1: 96.836,
    y2: 99.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 43.724,
    x2: 40.795,
    y1: 94.236,
    y2: 95.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 44.95,
    x2: 38.445,
    y1: 88.532,
    y2: 88.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562E65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 48.736,
    x2: 53.811,
    y1: 105.145,
    y2: 116.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 39.617,
    x2: 49.041,
    y1: 140.802,
    y2: 118.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 40.53,
    x2: 42.863,
    y1: 150.005,
    y2: 137.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDevelopment);
export default __webpack_public_path__ + "static/media/app-development.89f1cefc911fef9cd411073e1bcfc9e1.svg";
export { ForwardRef as ReactComponent };